export default __webpack_public_path__ + "static/media/Inter-Medium.eec0ea57.woff";